import React from 'react';
import videoPlayer from '../assets/video-player.png';
import product4 from '../assets/product4.png';
import { Link } from 'react-router-dom'


const WebDevDiv3 = (props) => {
    return (
        <div className="py-5" style={{ background: 'linear-gradient(to right, #e6f7fb, #f5fcff)' }}>
            <h1 className="fw-bold text-uppercase" style={{ color: 'rgb(4,180,228)' }}>
                Why WARALS Website Development is Unique in Offerings
            </h1>
            <div className="container-lg">
                <div className="row align-items-start">
                    {/* Left Column */}
                    <div className="col-md-6 mb-4 mb-md-0 ">
                        <p className="text-uppercase fw-semibold text-danger mb-2">
                            {props.smallHeading}
                        </p>
                        <h2 className="fw-bold mb-3">
                            {props.largeHeading}
                        </h2>
                        <p className="text-muted fw-light mb-4">
                            {props.lightHeading}
                        </p>

                        {/* Features */}
                        <div className="d-flex align-items-start mb-4 ">
                            <img
                                src="https://img.icons8.com/ios-filled/50/000000/monitor.png"
                                alt="Design Icon"
                                className="me-3"
                                style={{ width: '40px' }}
                            />
                            <div className='text-start'>
                                <h5 className="fw-bold mb-1 text-start ">Aesthetics Designs</h5>
                                <p className="text-muted mb-0 text-start">
                                    Design is the process of combining form and content. There is no single definition for design, just as there is no single definition for art. Design can be considered an art form.
                                </p>
                            </div>
                        </div>

                        <div className="d-flex align-items-start mb-4">
                            <img
                                src="https://img.icons8.com/ios-filled/50/000000/money.png"
                                alt="Price Icon"
                                className="me-3"
                                style={{ width: '40px' }}
                            />
                            <div className='text-start'>
                                <h5 className="fw-bold mb-1">Reasonable Price</h5>
                                <p className="text-muted mb-0">
                                    Our services come at a reasonable cost. We constantly provide high-quality services at a reasonable cost.
                                </p>
                            </div>
                        </div>

                        <div className="d-flex align-items-start mb-4">
                            <img
                                src="https://img.icons8.com/ios-filled/50/000000/handshake.png"
                                alt="Handshake Icon"
                                className="me-3"
                                style={{ width: '40px' }}
                            />
                            <div className='text-start'>
                                <h5 className="fw-bold mb-1">Trusted Partnership</h5>
                                <p className="text-muted mb-0">
                                    We believe in building long-term relationships with our clients based on trust, transparency, and consistent delivery of quality work.
                                </p>
                            </div>
                        </div>


                        {/* Contact Us Button */}
                        <div className='text-start'>

                             <h4 className="fw-bold text-dark text-start text-uppercase">Let's Work on a New Project</h4>

                        <Link
                            to="/contact-us"
                            className="btn text-start btn-light d-inline-flex align-items-center gap-2 px-4 py-2 fw-semibold rounded-pill my-3 shadow-sm"
                            style={{ fontSize: '1.1rem', color: '#00b8f1', border: "1px solid rgb(4,180,228)" }}
                        >
                            Contact Us <i className="fas fa-hand-point-right ms-2"></i>
                        </Link>
                        
                        </div>
                       
                    </div>

                    {/* Right Column */}
                    <div className="col-md-6 text-center">
                        <img
                            src={product4}
                            alt="Video Player"
                            className="img-fluid rounded"
                            style={{ maxHeight: '350px' }}
                        />
                        <p className="text-muted mt-3">
                            We've been the leading Indian website design business for over 10 years, providing cutting-edge design and website development services.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WebDevDiv3;
